import { useEffect, useState } from "react";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { Challenge } from "@/models/database/challenges/challenge.model";

export const useChallengeSlugForRedirect = (game: string) => {
  const [slug, setSlug] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const findOngoingChallenge = async () => {
    try {
      setLoading(true);

      const ongoingRef = await collectionRef.challenge
        .where("status", "==", "ongoing")
        .where("client", "==", brand.tenantId)
        .where("gameType", "==", game)
        .where("type", "==", "public")
        .get();

      const challData = ongoingRef?.docs?.[0]?.data() as Challenge;

      if (challData) {
        const slug = challData.slug;
        setSlug(slug);
      } else {
        const query = collectionRef.challenge
          .where("status", "==", "finished")
          .where("client", "==", brand.tenantId)
          .where("gameType", "==", game)
          .where("type", "==", "public");

        const finishedRef = await query.orderBy("endDate", "desc").get();

        const challDataEnded = finishedRef?.docs[0]?.data() as Challenge;

        const slug = challDataEnded.slug;
        setSlug(slug);
      }

      setLoading(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    findOngoingChallenge();
  }, []);

  return {
    data: slug,
    loading,
    error,
    findOngoingChallenge,
  };
};
